module.exports = __webpack_public_path__ + "static/media/productValues3.017caa8c.svg";